import { Flex, Menu, MenuItem, MenuPopper, Tabs } from '@zillow/constellation';

import { RMW_PATH } from '../../../../pathsManifest';
import NavItem from '../NavItem';
import { StyledMoreSpacer, StyledNavigationContainer, StyledTabsTab } from '../../StyledComponents';
import { NAV_ITEM_TITLE } from '../../index';
import AppSelectors from '../../../../selectors/AppSelectors';
import { useSelector } from '../../../../selectors/useSelector';
import { StyledLink, StyledText } from '../NavItem/StyledComponents';

type Props = {
  activePath: string;
  dashboardPathObj: { [key: string]: string };
};

const Navigation = ({ activePath, dashboardPathObj: DASHBOARD_PATH }: Props) => {
  const isScreenMobile = useSelector((state) => AppSelectors.makeIsScreenMobile(state));

  const renderOverflowNavItems = ({ isInMenuPopper = false }) => {
    const tabs = [
      {
        id: RMW_PATH.DASHBOARD_PAYMENTS,
        title: NAV_ITEM_TITLE.DASHBOARD_PAYMENTS,
        isActive: activePath === RMW_PATH.DASHBOARD_PAYMENTS,
        toPath: DASHBOARD_PATH.payments,
      },
      {
        id: RMW_PATH.DASHBOARD_MAINTENANCE_TASKS,
        title: NAV_ITEM_TITLE.DASHBOARD_MAINTENANCE_TASKS,
        isActive: activePath === RMW_PATH.DASHBOARD_MAINTENANCE_TASKS,
        toPath: DASHBOARD_PATH.maintenanceTasks,
      },
    ];

    if (isInMenuPopper) {
      return tabs.map((tab) => (
        <MenuItem
          as={StyledLink}
          to={{
            pathname: tab.toPath,
          }}
        >
          <NavItem title={tab.title} isActive={tab.isActive} isInMenuPopper={isInMenuPopper} toPath={tab.toPath} />
        </MenuItem>
      ));
    } else {
      return tabs.map((tab) => (
        <StyledTabsTab id={tab.id} key={tab.id}>
          <NavItem title={tab.title} isActive={tab.isActive} isInMenuPopper={isInMenuPopper} toPath={tab.toPath} />
        </StyledTabsTab>
      ));
    }
  };

  return (
    <StyledNavigationContainer>
      <Tabs.List aria-label="Navigation" fluid={{ default: true, md: false }}>
        <StyledTabsTab id={RMW_PATH.DASHBOARD_OVERVIEW}>
          <NavItem
            title={NAV_ITEM_TITLE.DASHBOARD_OVERVIEW}
            isActive={activePath === RMW_PATH.DASHBOARD_OVERVIEW}
            toPath={DASHBOARD_PATH.overview}
          />
        </StyledTabsTab>

        <StyledTabsTab id={RMW_PATH.DASHBOARD_LISTING}>
          <NavItem
            title={NAV_ITEM_TITLE.DASHBOARD_LISTING}
            isActive={activePath === RMW_PATH.DASHBOARD_LISTING}
            toPath={DASHBOARD_PATH.listing}
          />
        </StyledTabsTab>

        <StyledTabsTab id={RMW_PATH.DASHBOARD_APPLICATIONS}>
          <NavItem
            title={NAV_ITEM_TITLE.DASHBOARD_APPLICATIONS}
            isActive={activePath === RMW_PATH.DASHBOARD_APPLICATIONS}
            toPath={DASHBOARD_PATH.applications}
          />
        </StyledTabsTab>

        <StyledTabsTab id={RMW_PATH.DASHBOARD_LEASES}>
          <NavItem
            title={NAV_ITEM_TITLE.DASHBOARD_LEASES}
            isActive={activePath === RMW_PATH.DASHBOARD_LEASES}
            toPath={DASHBOARD_PATH.leases}
          />
        </StyledTabsTab>

        {isScreenMobile ? (
          <Flex display="flex" flexDirection="column" paddingRight="sm" alignItems="center">
            <MenuPopper triggered={<Menu>{renderOverflowNavItems({ isInMenuPopper: true })}</Menu>} />
            <StyledMoreSpacer marginBottom="sm">
              <StyledText fontType="finePrint" fontColor="textMedium">
                More
              </StyledText>
            </StyledMoreSpacer>
          </Flex>
        ) : (
          renderOverflowNavItems({ isInMenuPopper: false })
        )}
      </Tabs.List>
    </StyledNavigationContainer>
  );
};

export default Navigation;
